// extracted by mini-css-extract-plugin
export default {"container":"Header_container__uxFjY"};